import { render, staticRenderFns } from "./UldkAttributesMappingSettings.vue?vue&type=template&id=50865304&scoped=true&"
import script from "./UldkAttributesMappingSettings.vue?vue&type=script&lang=js&"
export * from "./UldkAttributesMappingSettings.vue?vue&type=script&lang=js&"
import style0 from "./UldkAttributesMappingSettings.vue?vue&type=style&index=0&id=50865304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50865304",
  null
  
)

export default component.exports